import DefaultService from '../Default';
const COLLECTION = 'connections';

class ConnectionsService extends DefaultService {
  constructor() {
    super(COLLECTION);
  }
  async get_data(endPoint: string): Promise<any> {
    const res = await this.fetchJson<any>(endPoint, {
      method: 'GET',
    });
    return res;
  }
  async post_data(endPoint: string, body: any = []) {
    const res = await this.fetchJson<any>(endPoint, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return res;
  }
  async put_data(endPoint: string, body: any = []) {
    const res = await this.fetchJson<any>(endPoint, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
    return res;
  }
  async delete_data(endPoint: string) {
    const res = await this.fetchJson<any>(endPoint, {
      method: 'DELETE',
    });
    return res;
  }
  async get_custom_data(endPoint: string): Promise<any> {
    const res = await this.fetchCustomContentType(endPoint, {
      method: 'GET',
    });
    return res;
  }
}

export default ConnectionsService;
